import React from 'react';
import { toast } from 'react-hot-toast';

// ###### COMPONENT
const CardPluggyAccounts = ({
  items,
  selectedItemId,
  setSelectedItemId,
  accounts,
  setAccounts,
  loading,
  setLoading,
  getPluggyAccounts,
  syncPluggyAccounts
}) => {
  const handleGetAccounts = async () => {
    try {
      if (!selectedItemId) {
        toast.error('Please select an item first.');
        return;
      }
      setLoading(prev => ({ ...prev, accounts: true }));
      let syncResult = null;
      if (syncPluggyAccounts) {
        syncResult = await syncPluggyAccounts({ item_id: selectedItemId });
      }
      const res = await getPluggyAccounts(selectedItemId);
      setAccounts(res || []);
      const synced = syncResult?.accounts_synced;
      if (syncResult && synced === 0) {
        toast.error(
          'Pluggy returned 0 accounts for this item. The bank connection may be expired or need re-linking in Pluggy.',
          { duration: 6000 }
        );
      } else if ((res || []).length === 0) {
        toast.error('No cached accounts. Try syncing from Pluggy first.', { duration: 5000 });
      } else {
        toast.success(`${(res || []).length} account(s) loaded`);
      }
    } catch (err) {
      const msg = err.response?.data?.error || err.message || 'Error fetching accounts';
      toast.error(msg);
      console.error('Error fetching accounts:', err);
    } finally {
      setLoading(prev => ({ ...prev, accounts: false }));
    }
  };

  return (
    <div className="bg-white p-6 mt-2 rounded-2xl shadow flex-1">
      <h2 className="text-xl font-semibold">Pluggy Accounts</h2>
      <div className="mt-4 flex flex-col gap-4">
        {items.length > 0 ? (
          <>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Select item:</label>
              <select
                value={selectedItemId}
                onChange={(e) => setSelectedItemId(e.target.value)}
                className="border p-2 rounded w-full"
              >
                <option value="">-- Select --</option>
                {items.map((item) => (
                  <option key={item.item_id} value={item.item_id}>
                    {item.institution} – {item.item_id}
                  </option>
                ))}
              </select>
            </div>
            <button onClick={handleGetAccounts} className="bg-green-800 text-white px-4 py-2 rounded-lg w-fit">
              {loading.accounts ? 'Loading...' : 'Sync from Pluggy & list'}
            </button>
            {accounts.length > 0 && (
              <div>
                <h3 className="text-md font-semibold mt-2">Cached accounts (no live balance):</h3>
                <ul className="list-disc list-inside text-sm text-gray-700">
                  {accounts.map((acc) => (
                    <li key={acc.id}>
                      {acc.name || acc.id} – {acc.type}
                      {acc.currencyCode ? ` (${acc.currencyCode})` : ''}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </>
        ) : (
          <p className="text-sm text-gray-500">No Pluggy items registered for this user</p>
        )}
      </div>
    </div>
  );
};

export default CardPluggyAccounts;
